import * as React from 'react';
import { IQuestionLayoutProps } from '@cian/frontend-request-form-widget';
import { useSelector } from 'react-redux';

import { EStepCode } from '../../types/requestFormSchema';
import { PaymentStepContainer } from '../PaymentStepContainer/PaymentStepContainer';
import { CustomQuestionLayout } from '../../components/CustomQuestionLayout';
import { IRequestFormQuestion } from '../../types/requestForm';
import { NewYearContainer } from '../NewYearContainer';
import { selectServiceMessage } from '../../selectors/serviceMessage';

export const QuestionLayoutContainer: React.FC<IQuestionLayoutProps<IRequestFormQuestion>> = props => {
  const { isNewYearAlertShouldShown, isNewYearAlertShown } = useSelector(selectServiceMessage);

  /** Уведомление о работе в новогодние праздники **/
  if (isNewYearAlertShouldShown && !isNewYearAlertShown && props.question.code === EStepCode.ObjectType) {
    return <NewYearContainer />;
  }

  if (props.question.code === EStepCode.PayForReport) {
    return <PaymentStepContainer {...props} />;
  }

  return <CustomQuestionLayout {...props} />;
};

QuestionLayoutContainer.displayName = 'QuestionLayoutContainer';
